import { render } from "./EventCreate.vue?vue&type=template&id=aba3b4e0"
import script from "./EventCreate.vue?vue&type=script&lang=js"
export * from "./EventCreate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__